import React, { useContext, useState } from 'react';

import { useParams } from 'react-router-dom';
import { useQuery } from 'react-query';

import jwt_decode from 'jwt-decode';
import Swal from 'sweetalert2';

import ConsultantCheckoutContext from 'src/contexts/consultantCheckout';
import FooterCheckout from 'src/components/functional/FooterCheckout';
import CheckoutHeader from 'src/components/functional/HeaderCheckout';
import { apiCheckoutConsultant } from '../../api';

import ChoosePaymentMethod from './components/ChoosePaymentMethod';
import PurchaseForms from './components/PurchaseForms';
import PurchaseResume from './components/PurchaseResume';

import { CheckoutComponent, ContainerCheckout, ContainerContent } from './style';

import loadingGIF from '../../../../assets/gifs/loading.png';

export default function CheckoutConsultantServices(): JSX.Element {
  const [customerData, setCustomerData] = useState({
    customerName: '',
    customerEmail: '',
    customerCpf: '',
    zipCode: '',
    street: '',
    neighborhood: '',
    city: '',
    state: '',
    streetNumber: '',
    customerPhone: '',
    consultantName: '',
    consultantEmail: '',
    consultantId: 0,
    splitPercentage: 0,
    origin: '',
  });
  const [serviceData, setServiceData] = useState({
    serviceName: '',
    serviceValue: 0,
    consultantRecipientId: '',
    customerAppointmentId: 0,
    appointments: [],
  });

  const [component, setComponent] = useState(0);

  const { setFullAppointmentData } = useContext(ConsultantCheckoutContext);

  const { token } = useParams();

  const dataToken: { appointmentCustomerId: string } = jwt_decode(token);

  const { isLoading, isError } = useQuery(
    ['getAppointmentCheckoutData'],
    async () => apiCheckoutConsultant.getAppointmentCheckoutData(dataToken.appointmentCustomerId),
    {
      onError: () => {
        void Swal.fire({
          icon: 'error',
          title: 'Ocorreu um erro ao recuperar os dados!',
          text: 'Por favor, tente novamente mais tarde, ou contate a central.',
          iconColor: 'black',
          confirmButtonColor: 'black',
        });
      },
      onSuccess: (fullAppointmentData) => {
        setCustomerData({
          customerName: fullAppointmentData.customerName,
          customerEmail: fullAppointmentData.customerEmail,
          customerCpf: '',
          zipCode: '',
          street: '',
          neighborhood: '',
          city: '',
          state: '',
          streetNumber: '',
          customerPhone: fullAppointmentData.customerPhone,
          consultantName: fullAppointmentData.consultantName,
          consultantEmail: fullAppointmentData.consultantEmail,
          consultantId: fullAppointmentData.consultantId,
          splitPercentage: fullAppointmentData.splitPercentage,
          origin: fullAppointmentData.origin,
        });
        setServiceData({
          serviceName: fullAppointmentData.serviceName,
          serviceValue: +fullAppointmentData.paymentValue,
          consultantRecipientId: fullAppointmentData.recipientId,
          customerAppointmentId: +dataToken.appointmentCustomerId,
          appointments: fullAppointmentData.appointments,
        });
        setFullAppointmentData(fullAppointmentData);
      },
      refetchOnWindowFocus: false,
    }
  );

  const renderComponent = (): JSX.Element => {
    if (component === 0) {
      return (
        <PurchaseForms
          customerData={customerData}
          setCustomerData={setCustomerData}
          setComponent={setComponent}
        />
      );
    }
    return (
      <ChoosePaymentMethod
        customerData={customerData}
        setComponent={setComponent}
        serviceData={serviceData}
      />
    );
  };

  return (
    <ContainerCheckout>
      <CheckoutHeader />
      {isLoading || isError ? (
        <img src={loadingGIF} alt="Loading spinning" width="100" height="100" />
      ) : (
        <>
          <ContainerContent>
            <PurchaseResume />
            <CheckoutComponent>{renderComponent()}</CheckoutComponent>
          </ContainerContent>
          <FooterCheckout />
        </>
      )}
    </ContainerCheckout>
  );
}
